import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Navbar from './components/Navbar';
import HomePage from './Pages/HomePage';
import CartPage from './Pages/CartPage';
import FavoritesPage from './Pages/FavoritesPage';
import NotFoundPage from './Pages/NotFoundPage';
import CartContextProvider from './context/CartContext';
import FavoritesContextProvider from './context/FavoritesContext';
import ProductDetail from './components/ProductDetail';
import Formulaire from './Pages/Formulaire';
import JeuxVideos from './Pages/JeuxVideos';
import Contact from './Pages/Contact';
import { UserProvider } from './context/UserContext';
import Login from './components/Login';
import LogPage from './components/LogPage';
import Register from './components/Register';
import MesCommandes from './components/MesCommandes';
import Profil from './Pages/Profil';
import Cartes from './Pages/Cartes';
import Itunes from './Pages/iTunes';
import SearchPage from './Pages/SearchPage';
import PaymentForm from './components/PaymentForm';
import Apropos from './Pages/Apropos';
import Nouveautes from './Pages/Nouveautes';
import PS4 from './Pages/PS4.jsx';
import JeuxPs5 from './Pages/JeuxPs5.jsx';
import Installer from './Pages/Installer.jsx';
import Playstations from './Pages/Playstations.jsx';
import PromoMarquee from './components/PromoMarquee.jsx';
import ResetPassword from './components/ResetPassword.jsx';
import GuestRoute from './components/GuestRoute.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import CD from './Pages/CD.jsx';


const App = () => {
    const [user, setUser] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const handleLogin = (userData) => {
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
    };

    const handleRegister = (userData) => {
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
    };

    const handleLogout = () => {
        setUser(null);
        localStorage.removeItem('user');
    };

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const handleSelectCategory = (categoryId) => {
        setSelectedCategory(categoryId);
    };

    return (
        <>
        <UserProvider>
            <CartContextProvider>
                <FavoritesContextProvider>
                    <Router>
                        <PromoMarquee/>
                        <Navbar user={user} onLogout={handleLogout} />
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/JeuxVideos" element={<JeuxVideos selectedCategory={selectedCategory} onSelectCategory={handleSelectCategory} />} />
                            <Route path="/product/:id" element={<ProductDetail />} />
                            <Route path="/cart" element={<CartPage />} />
                            <Route path="/favorites" element={<FavoritesPage />} />
                             <Route path="/reset-password/:token" element={<ResetPassword />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/formulaire" element={<Formulaire />} />
                            <Route path="/loginPage" element={<LogPage onLogin={handleLogin} />} />
                           <Route path="/login" element={ <GuestRoute><Login onLogin={handleLogin} /></GuestRoute> }/>
                           <Route path="/register" element={<GuestRoute><Register onRegister={handleRegister} /></GuestRoute>}/>
                            <Route path="*" element={<NotFoundPage />} />
                            <Route path="/mes-commandes" element={<MesCommandes />} />
                            {/* <Route path="/mes-commandes" element={<ProtectedRoute><MesCommandes /></ProtectedRoute>} /> */}
                             <Route path="/Profil" element={<Profil />} />
                            <Route path="/Cartes__PSN" element={<Cartes />} />
                            <Route path="/CD" element={<CD />} />
                            <Route path="/Cartes__itunes" element={<Itunes />} />
                            <Route path="/search" element={<SearchPage />} />
                            <Route path="/paiement" element={<PaymentForm />} />
                             <Route path="/Contactez-nous" element={<Contact />} />
                            <Route path="/A__propos" element={<Apropos />} />
                            <Route path="/nouveautes" element={<Nouveautes />} />
                            <Route path="/fr/PS4" element={<PS4 />} />
                            <Route path="/fr/PS5" element={<JeuxPs5 />} />
                             <Route path="/boutique" element={<Playstations />} />
                             <Route path="/comment__installer/" element={<Installer />} />
                        </Routes>
                    </Router>
                </FavoritesContextProvider>
            </CartContextProvider>
        </UserProvider>
         <Toaster position="top-right" />
        </>
    );
};

export default App;